<template>
    <div class="website-chatbot-builder">
        <md-progress-bar
            md-mode="indeterminate"
            v-if="
                [
                    STATES.TRAINING,
                    STATES.ATTRIBUTES_CALCULATING,
                    STATES.CHATBOT_CREATING,
                    STATES.SCRAPPING,
                    STATES.TUNING_CHATBOT,
                ].includes(state)
            "
        />
        <div class="content-wrapper">
            <div class="steper-header">
                <div class="state-viewer" v-if="state !== 'not-started'">
                    <i
                        class="material-icons"
                        :class="{
                            spin: [
                                STATES.TRAINING,
                                STATES.ATTRIBUTES_CALCULATING,
                                STATES.CHATBOT_CREATING,
                                STATES.SCRAPPING,
                                STATES.TUNING_CHATBOT,
                            ].includes(state),
                        }"
                        >autorenew</i
                    >
                    <span>{{ getStateText() }}</span>
                </div>
                <div class="top-navigation">
                    <div class="step">
                        <i class="completed material-icons">check</i>
                        <div class="name">{{ $t("chatbotv2.setupChatbot") }}</div>
                    </div>
                    <div class="step">
                        <i class="completed material-icons" v-if="activeStep === 3">check</i>
                        <div class="number" v-else>2</div>
                        <div class="name">{{ $t("chatbotv2.train") }}</div>
                    </div>
                    <div class="step" :class="{ inactive: activeStep < 3 }">
                        <div class="number">3</div>
                        <div class="name">{{ $t("chatbotv2.tuneChatbot") }}</div>
                    </div>
                </div>
            </div>
            <div class="traning">
                <WebsiteTrain
                    builderMode
                    @state="updateState"
                    @scrapper-state="(data) => (scrapperState = data)"
                    v-if="activeStep === 2"
                    v-model="url"
                />
                <TuneChatbot v-if="activeStep === 3" v-model="tuningParams" />
            </div>
        </div>
        <div class="footer-actions">
            <SupsisButton ghost xlarge @click="cancel">{{ $t("message.cancel") }}</SupsisButton>
            <SupsisButton primary xlarge :disabled="!isNextEnabled()" @click="next">
                {{ activeStep === 3 ? $t("chatbotv2.complete") : $t("chatbotv2.continue") }}
            </SupsisButton>
        </div>
        <div class="background-accent"></div>
    </div>
</template>
<script>
import Vue from "vue";
import WebsiteTrain from "../../ai/WebsiteTrain.vue";
import SupsisButton from "../../../Settings/components/SupsisButton.vue";
import { sendSocketMessage, socketMessageStream } from "../../../../../utils/socketStream";
import { mapState } from "vuex";
import log2 from "../../../../../utils/log2";
import TuneChatbot from "./TuneChatbot.vue";
import SYSTEM_PUBSUB from "../../../../../utils/systemPubSub";

const log = log2("WebsiteChatbotBuilder");
const STATES = {
    STORY_CREATED: "story-created",
    SCRAPPING: "scrapping",
    SCRAPPING_COMPLETED: "scrapping-finished",
    TRAINING: "training",
    ATTRIBUTES_CALCULATING: "attributes-calculating",
    ATTRIBUTES_CALCULATED: "attributes-calculated",
    CHATBOT_CREATING: "chatbot-creating",
    COMPLETED: "completed",
    TUNING_CHATBOT: "tuning-chatbot",
    NOT_STARTED: "not-started",
};
export default Vue.extend({
    name: "WebsiteChatbotBuilder",
    components: { TuneChatbot, SupsisButton, WebsiteTrain },
    data() {
        return {
            STATES,
            activeStep: 2,
            state: STATES.NOT_STARTED,
            storyId: null,
            selectedPageIds: [],
            socialLinks: [],
            url: "",
            tuningParams: {
                attributes: {},
                welcomeText: "",
                enabledButtons: null,
            },
            scrapperState: null,
        };
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            userId: (state) => state.auth.user?._id,
        }),
    },
    methods: {
        isValidUrl() {
            try {
                const url = this.url.startsWith("http") ? this.url : `https://${this.url}`;
                const regex = new RegExp(
                    "https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)",
                    "gmi"
                );
                return regex.test(url);
            } catch (e) {
                return false;
            }
        },
        getStateText() {
            if (this.state === STATES.STORY_CREATED) {
                return "Creating story";
            } else if (this.state === STATES.SCRAPPING) {
                const completedPageCount = _.get(this.scrapperState, "completedPageCount");
                return completedPageCount
                    ? `Scrapping website (${completedPageCount} page scrapped)`
                    : "Scrapping website";
            } else if (this.state === STATES.SCRAPPING_COMPLETED) {
                return "Scrapping finished";
            } else if (this.state === STATES.TRAINING) {
                return "Training chatbot";
            } else if (this.state === STATES.ATTRIBUTES_CALCULATING) {
                return "Calculating attributes";
            } else if (this.state === STATES.ATTRIBUTES_CALCULATED) {
                return "Attributes calculated";
            } else if (this.state === STATES.CHATBOT_CREATING) {
                return "Creating chatbot";
            } else if (this.state === STATES.COMPLETED) {
                return "Completed";
            } else if (this.state === STATES.TUNING_CHATBOT) {
                return "Tuning chatbot";
            }
        },
        updateState(data) {
            log("updateState", data);
            if (data.state === STATES.STORY_CREATED) {
                this.storyId = data.storyId;
            } else if (data.state === STATES.ATTRIBUTES_CALCULATED) {
                this.tuningParams.attributes = data.attributes;
                this.tuningParams.welcomeText = `${data.attributes.company_name} sitesine hoşgeldiniz. Ben  dijital asistanızım. Size nasıl yardımcı olabilirim?`;
                this.activeStep = 3;
            }
            if (Array.isArray(data.selectedPageIds)) {
                this.selectedPageIds = data.selectedPageIds;
            }
            if (Array.isArray(data.socialLinks)) {
                this.socialLinks = data.socialLinks;
            }

            this.state = data.state;
        },
        listenSocket() {
            this.sub = socketMessageStream.subscribe(({ cmd, data }) => {
                if (cmd === "website_chatbot_builder_state") {
                    this.state = data.state;
                }
            });
        },
        cancel() {
            this.$emit("cancel");
        },
        isNextEnabled() {
            console.log("isNextEnabled", this.state);
            if (this.state === STATES.NOT_STARTED) return this.isValidUrl();
            else {
                return [STATES.ATTRIBUTES_CALCULATED, STATES.SCRAPPING_COMPLETED].includes(this.state);
            }
        },

        next() {
            log("train called", this.selectedPageIds);
            if (this.state === STATES.NOT_STARTED) {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.START_SCRAPE_WEBSITE, {});
            } else if (this.state === STATES.ATTRIBUTES_CALCULATED) {
                this.tuneChatbot();
            } else {
                sendSocketMessage("chatbot/v2 complete-website-chatbot-train", {
                    siteId: this.siteId,
                    storyId: this.storyId,
                    userId: this.userId,
                    pageIds: this.selectedPageIds,
                    socialLinks: this.socialLinks,
                    url: this.url,
                });
                this.state = STATES.TRAINING;
            }
        },
        tuneChatbot() {
            log("tuneChatbot", this.tuningParams);
            this.state = STATES.TUNING_CHATBOT;
            sendSocketMessage("chatbot/v2 tune-website-chatbot", {
                siteId: this.siteId,
                storyId: this.storyId,
                userId: this.userId,
                attributes: this.tuningParams.attributes,
                welcomeText: this.tuningParams.welcomeText,
                enabledButtons: this.tuningParams.enabledButtons,
            });
        },
    },
    mounted() {
        this.listenSocket();
    },
    beforeDestroy() {
        this.sub.unsubscribe();
    },
    watch: {
        state: {
            handler: function (newState) {
                if (newState === STATES.COMPLETED) {
                    this.$message.success({
                        content: `Chatbot tuning completed successfully.`,
                        duration: 2,
                    });
                    setTimeout(() => {
                        this.$router.push(`/chatbot/story/${this.storyId}/1.0`);
                    }, 500);
                }
            },
            deep: true,
        },
        url() {
            console.log("url changed", this.url);
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },
    },
});
</script>
<style lang="scss">
.material-icons {
    &.spin {
        animation: spin 1s linear infinite;
    }
}
</style>
<style scoped lang="scss">
.website-chatbot-builder {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0 100px;
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;

    .content-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        gap: 5px;
        flex-direction: column;
        position: relative;
        overflow: hidden;
        overflow-y: auto;
        margin-bottom: 150px;

        &::-webkit-scrollbar {
            height: 0;
            width: 0;
            display: none;
        }
    }

    .md-progress-bar {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 99999;
    }

    .top-navigation {
        display: flex;
        gap: 20px;
        height: 100px;
        margin-left: -40px;
        overflow-y: auto;
        padding: 0 40px;
        position: sticky;
        top: 0;
        user-select: none;
        width: calc(100% + 80px);
        z-index: 9999;
        background: white;

        .step {
            display: flex;
            align-items: center;

            .material-icons {
                &.completed {
                    display: flex;
                    align-items: center;
                    background: #cce2ff;
                    border-radius: 100%;
                    color: #006cff;
                    font-size: 8px;
                    font-weight: 700;
                    height: 18px;
                    justify-content: center;
                    width: 18px;
                }
            }

            .name {
                font-size: 14px;
                font-weight: 600;
                line-height: 18px;
                margin-left: 10px;
            }

            .number {
                font-size: 10px;
                font-weight: 600;
                line-height: 14px;
                background: #dcdcdc;
                border-radius: 100%;
                height: 18px;
                justify-content: center;
                width: 18px;
                display: flex;
                align-items: center;
            }

            &.inactive {
                .number {
                    background: #f5f5f5;
                    color: #979797;
                }
            }
        }
    }

    .state-viewer {
        position: absolute;
        top: 100px;
        right: 100px;
        display: flex;
        gap: 5px;
        align-items: center;
        color: #006cff;
    }

    .footer-actions {
        bottom: 0;
        height: 100px;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: flex-end;
        position: absolute;
        padding: 0px 100px;
        gap: 5px;
        z-index: 3;
    }

    .background-accent {
        background: #ff7a00;
        bottom: -400px;
        filter: blur(100px);
        height: 500px;
        left: -700px;
        position: absolute;
        width: 900px;
        z-index: -1;
    }
}
</style>
